import styled from 'styled-components';

import { Anchor, Text, token } from '@zillow/constellation';

export const StyledAnchor = styled(Anchor)`
  color: ${token('colors.black')};

  &:visited {
    color: ${token('colors.black')};
  }
`;

type Props = {
  partialMessages: Array<{
    className: string;
    isBold: boolean;
    text: string;
    url: string;
  }>;
  fontType?: 'body' | 'bodySmall' | 'finePrint';
  useStyledAnchor?: boolean;
};

const PartialMessage = ({ partialMessages = [], fontType = 'body', useStyledAnchor = false }: Props) => {
  const Link = useStyledAnchor ? StyledAnchor : Anchor;

  return (
    <div data-testid="PartialMessage">
      {partialMessages.map(({ url, text, isBold }, i) => (
        <Text key={`partial-message-${text}`} fontType={isBold ? `${fontType}Heading` : fontType}>
          {url ? (
            <Link key={i} href={url} target="_blank">
              {`${text}`}
            </Link>
          ) : (
            `${text}`
          )}
        </Text>
      ))}
    </div>
  );
};

export default PartialMessage;
